<script setup>
import {Dialog, DialogOverlay, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {useConfigStore} from "@/stores/config.js";

const configStore = useConfigStore()
const emit = defineEmits(['closeModal', 'applyFilter']);
const props = defineProps({
  filters: Array
})

function closeModal() {
  emit('closeModal');
}

function refresh() {
  window.location.reload(true)
}
</script>

<template>
  <TransitionRoot appear show as="template">
    <Dialog as="div" @close="closeModal" class="relative z-[9999]">
      <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-[black]/60"/>
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex overflow-hidden justify-center px-4 py-8">
          <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
          >
            <DialogPanel
                class="w-full flex flex-col overflow-hidden rounded-md max-w-fit text-left align-middle shadow-xl transition-all bg-white dark:bg-black-800 text-black-600 dark:text-white">
              <div class="p-5 flex-1 overflow-auto h-full flex flex-row gap-6 items-center">
                <div class="flex-1 text-sm">
                  Version {{configStore.latestVersion}} is available. Update now to use the latest version.
                </div>
                <button class="btn btn-outline-dark text-sm font-normal py-2" @click="refresh">Update</button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<style scoped lang="scss">

</style>